import { forwardRef, memo, useImperativeHandle, useRef } from "react";
import { Form, Modal, useForm, useTheme, type ModalRef } from "react-better-html";

import { modalMaxWidthSmall } from "../../constants/app";

import { type Workspace } from "../../types/workspace";

import { useSelectedOrganization } from "../../utils/hooks";
import { useI18n } from "../../utils/i18n";

type WorkspaceShareModalProps = {
   workspace: Workspace;
   onFinish?: () => void;
} & React.ComponentProps<typeof Modal>;

const WorkspaceShareModal = forwardRef<ModalRef, WorkspaceShareModalProps>(({ workspace, onFinish, ...props }, ref) => {
   const theme = useTheme();
   const { t } = useI18n();
   const selectedOrganization = useSelectedOrganization();

   const modalRef = useRef<ModalRef>(null);

   const form = useForm({
      defaultValues: {},
      onSubmit: (values) => {
         console.log(values);
      },
   });

   useImperativeHandle(ref, (): ModalRef => modalRef.current!, []);

   return (
      <Modal
         title={`${t((l) => l.common.share)} ${workspace.name}`}
         description={
            t(
               (l) =>
                  l.components.workspaceShareModal.description[
                     selectedOrganization ? selectedOrganization.type : "PERSONAL"
                  ],
               {
                  membersLimit: () => workspace.memberLimit ?? workspace.effectiveMemberLimit,
               },
            ) as string
         }
         maxWidth={modalMaxWidthSmall}
         {...props}
         ref={modalRef}
      >
         <Form form={form} gap={theme.styles.gap}></Form>
      </Modal>
   );
});

export default memo(WorkspaceShareModal);
